import { configuration } from '../configuration';
import { ClientResult } from './ClientResult';

export interface TagMetadata {
  key: string;
  label: string;
}

export async function getTags(tenant: string, locale: string): Promise<ClientResult<TagMetadata[]>> {
  const url = `${configuration.urls.MTS_URL}api/v1/tags-metadata/localized-values/tenant/${tenant}/locale/${locale}?requestor=${configuration.requestor}`;
  const result: Response = await fetch(url);

  if (!result.ok) {
    console.error(`TagsMetadataService: HTTP ${result.status} for ${url}`);
    return {
      failed: true,
      result: [],
    };
  }

  const tagsMap = (await result.json()) as Record<string, string>;
  const tags: TagMetadata[] = Object.entries(tagsMap).map(([key, label]) => ({
    key,
    label,
  }));

  return {
    failed: false,
    result: tags,
  };
}
